import { themeGet } from '@styled-system/theme-get';
import styled from 'styled-components';
import Text from '../../../shared/Text/Text';

const Box = styled.div`
  background-color: ${themeGet('colors.white')};
  border: 1px solid ${themeGet('colors.black.10')};
  border-radius: 8px;
  padding: 8px 24px;
`;

const Title = styled.div`
  margin-bottom: 1px;
  display: flex;
  justify-content: space-between;
`;

const Link = styled.a`
  color: ${themeGet('colors.primary.100')};
  font-size: 11px;
  font-weight: 600;
  font-family: 'Montserrat', sans-serif;
`;

const BoxMessage = ({ title, message, link = null, linkText = null }) => {
  const hasLink = link && linkText;

  return (
    <Box>
      <Title>
        <Text as="span" variant="subtitle2" color="black.80">
          {title}
        </Text>
        {hasLink && (
          <Link href={link} target="_blank">
            {linkText}
          </Link>
        )}
      </Title>
      <Text as="span" variant="small2">
        {message}
      </Text>
    </Box>
  );
};

export default BoxMessage;
